import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import Button from './Button';

function SpecialButton({ name, onClick, hasText = false }) {
  const [imageName, setImageName] = useState(`${name}.png`);

  useEffect(() => {
    setImageName(`${name}.png`);
  }, [name, setImageName]);

  const onClickWrapper = () => {
    if (onClick) onClick();
    if (hasText) {
      setImageName(`${name}-text.png`);
      setTimeout(() => setImageName(`${name}.png`), 2000);
    }
  };

  return (
    <Button className={`special ${name}-button`} onClick={onClickWrapper}>
      <img src={require(`../asset/img/${imageName}`)} alt={name} />
    </Button>
  );
}

SpecialButton.propTypes = {
  name: PropTypes.string.isRequired,
  onClick: PropTypes.func,
  hasText: PropTypes.bool
};

export default SpecialButton;
